import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import { getSchedaPersonaEsistenteViewlet, resetSchedaPersonaEsistenteViewlet } from 'uniba-volto-persone/actions';
import { addNavigationItem, removeNavigationItem } from 'design-comuni-plone-theme/actions';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import { SchedaPersonaModalView } from 'uniba-volto-persone/components';

function getCookie(name) {
    const cookies = document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${name}=`));

    return cookies ? cookies.split('=')[1] : null;
}

function setCookie(name, value, path = "/") {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=${path}`;
}

function SchedaPersonaEsistenteViewlet({ toastify }) {
    const [openPersonalModal, setOpenPersonalModal] = React.useState(false);
    function openOpenPersonalModal() {
        setOpenPersonalModal(true);
    }
    const [rubricaData, setRubricaData] = React.useState(null);
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const currentPath = location.pathname;
    const user_id = useSelector((state) =>
        state.userSession.token ? jwtDecode(state.userSession.token).sub : null,
    );
    const JUST_LOGGED_KEY = "csi.persone.loggedin";
    const justLoggedCookie = getCookie(JUST_LOGGED_KEY);
    const [hasRedirected, setHasRedirected] = React.useState(false);
    const [shownToast, setShownToast] = React.useState(false);

    //Chiamo la Viewlet ogni volta che l'username cambia e non è vuoto
    React.useEffect(() => {
        setShownToast(false);
        setHasRedirected(false);
        if (user_id) {
            dispatch(resetSchedaPersonaEsistenteViewlet(user_id));
            dispatch(getSchedaPersonaEsistenteViewlet(user_id));
        }
    }, [user_id]);

    // Stato del risultato della Viewlet
    const schedaPersonaState = useSelector((state) => state.schedaPersonaEsistenteViewletReducer?.items[user_id]);

    // Eseguo un redirect se lo stato della Viewlet lo impone
    React.useEffect(() => {
        if (schedaPersonaState?.redirect && user_id && !hasRedirected && justLoggedCookie == "true") {
            const redirect_path = schedaPersonaState.redirect;
            if (currentPath != redirect_path) {
                setTimeout(() => {
                    history.push(redirect_path);
                }, 1000);
            }
            setHasRedirected(true);
        }
    }, [currentPath, schedaPersonaState, user_id]);

    // Se è il primo accesso, imposto la modale aperta e scrivo il messaggio della Viewlet, poi rimuovo il cookie
    React.useEffect(() => {
        if (schedaPersonaState?.message && user_id && justLoggedCookie == "true") {
            if (!shownToast) {
                if (schedaPersonaState?.exit) {
                    toastify.toast.error(schedaPersonaState?.message, { autoClose: true });
                } else {
                    toastify.toast.success(schedaPersonaState?.message, { autoClose: true });
                }
                setShownToast(true);
            }
            if (!schedaPersonaState?.redirect && user_id) {
                setOpenPersonalModal(true);
            }
            setCookie(JUST_LOGGED_KEY, false);
        }
    }, [schedaPersonaState, user_id ]);

    const customNavigationItems = useSelector((state) => state.customNavigation.items);
    const navItemID = "SchedaPersonaleNavItem";

    const fetchRubricaData = async (uid) => {
        try {
            const response = await fetch(`/++api++/rubrica/${uid}`);
            if (!response.ok) {
                throw new Error('Errore durante il recupero dei dati della rubrica.');
            }
            const data = await response.json();
            setRubricaData(data);
        } catch (error) {
            console.error('Errore nel recupero dei dati:', error);
        }
    };

    // Se l'utente ha la scheda di rubrica, gli inserisco il pulsante per accedere ad essa
    React.useEffect(() => {
       
        if (schedaPersonaState?.message && user_id) {
            if (schedaPersonaState?.exists == true) {
                const oggetto = {
                    "id": navItemID,
                    "title": "Scheda Personale",
                    "description": "Accedi alla tua Scheda di Rubrica",
                    "url": "/rubrica/" + user_id,
                    "onClick": openOpenPersonalModal,
                    "items": []
                }
                const existingItem = customNavigationItems.find(item => item.id === oggetto.id);
                if (!existingItem) {
                    dispatch(addNavigationItem(oggetto));
                }
                if (!rubricaData) {
                    fetchRubricaData(user_id);
                }
            } else {
                if (user_id && schedaPersonaState?.exit == false) {
                    dispatch(getSchedaPersonaEsistenteViewlet(user_id));
                }
            }
        } else {
            dispatch(removeNavigationItem(navItemID));
            setRubricaData();
        }
    }, [schedaPersonaState, user_id, rubricaData]);

    return (
        <>
        {
            rubricaData && (
                <SchedaPersonaModalView
                    props={{ content: rubricaData, viewlet: true }}
                    startsOpen={openPersonalModal}
                    setOpen={setOpenPersonalModal}
                />
            )
        }
        </>
    );
};

export default injectLazyLibs(['toastify'])(SchedaPersonaEsistenteViewlet);